import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  fetchLocations,
  LocationsDto,
} from '../../services/fetchServices/fetchLocations';
import {
  fetchOrganizations,
  OrganizationsDto,
} from '../../services/fetchServices/HardwareApi/fetchHardwareMetadata';

type OfficesMetaData = OrganizationsDto & LocationsDto;

export function compare(
  a: { name: string; id: number },
  b: { name: string; id: number },
) {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();

  let comparison = 0;
  if (nameA > nameB) {
    comparison = 1;
  } else if (nameA < nameB) {
    comparison = -1;
  }
  return comparison;
}

export const useOfficesMetaData = () => {
  const [data, setData] = useState<OfficesMetaData>({
    organizations: [],
    locations: [],
  });

  useEffect(() => {
    const f = async () => {
      const responses = await Promise.all([fetchOrganizations(), fetchLocations()]);
      if (responses[0].type === 'success' && responses[1].type === 'success') {
        setData({
          organizations: responses[0].data.organizations.sort(compare),
          locations: responses[1].data.sort(compare),
        });
      } else {
        toast.error('Fetching office metadata failed');
      }
    };
    f();
  }, []);
  return data;
};
